import { LeftNavComponent } from './../../components/left-nav/left-nav.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { RmsLoadingSpinnerService } from './components/loading-spinner/rms-loading-spinner.service';
import { NgModule } from '@angular/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { CommonModule } from '@angular/common';
import { CheckboxModule } from 'primeng/checkbox';
import { Calendar, CalendarModule } from 'primeng/calendar';
import { SearchTeamTextboxComponent } from './components/search-team-textbox/search-team-textbox.component';
import { SearchTeamModalComponent } from './components/search-team-modal/search-team-modal.component';
import { UiNdmsModule } from '../../../../shared/ui-ndms/ui-ndms.module';
import { SearchResponderModalComponent } from './components/search-responder-modal/search-responder-modal.component';
import { SearchRespondersMultiModalComponent } from './components/search-responder-multi-modal/search-responders-multi-modal.component';
import { TeamsSelectComponent } from './components/teams-select/teams-select.component';
import { SearchAirportComponent } from "./components/search-airport/search-airport.component";
import { RmsNavComponent } from "../../components/rms-nav/rms-nav.component";
import { RmsHomeComponent } from "../../components/home/home.component";
import { TreeModule } from "primeng/tree";
import { ToastModule } from 'primeng/toast';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker'
import { UiTextboxComponent } from './controls/forms/ui-textbox/ui-textbox.component';
import { UiNumberComponent } from './controls/forms/ui-number/ui-number.component';
import { UiPhoneNumberComponent } from './controls/forms/ui-phone-number/ui-phone-number.component';
import { UiPostalCodeComponent } from './controls/forms/ui-postal-code/ui-postal-code.component';
import { UiEmailAddressComponent } from './controls/forms/ui-email-address/ui-email-address.component';
import { UiDropDownComponent } from './controls/forms/ui-dropdown/ui-dropdown.component';
import { UiDateComponent } from './controls/forms/ui-date/ui-date.component';
import { UiFormPanelComponent } from './controls/forms/ui-form-panel/ui-form-panel.component';
import { UiFormCardPanelComponent } from './controls/forms/ui-form-card-panel/ui-form-card-panel.component';
import { UiFormCardPanelContainerComponent } from './controls/forms/ui-form-card-panel/ui-form-card-panel-container.component';
import { UiDropdownWithButtonComponent } from './controls/forms/ui-dropdown-with-button/ui-dropdown-with-button.component';
import { UiPrintErrorsComponent } from './controls/forms/ui-print-errors/ui-print-errors.component';
import { ProgramCardComponent } from '../../components/program-card/program-card.component';
import { UiCheckboxComponent } from './controls/forms/ui-checkbox/ui-checkbox.component';
import { UiPrimengCheckboxComponent } from './controls/forms/ui-checkbox/ui-primeng-checkbox/ui-primeng-checkbox.component';
import { UiBasicCheckboxComponent } from './controls/forms/ui-checkbox/ui-basic-checkbox/ui-basic-checkbox.component';
import { TextMaskModule } from "angular2-text-mask";
import { UiTextareaComponent } from './controls/forms/ui-textarea/ui-textarea.component';
import { SearchCertificationTypeComponent } from './components/search-certification-type/search-certification-type.component';
import { UiSSNComponent } from "./controls/forms/ui-ssn/ui-ssn.component";
import { UiCheckmarkComponent } from './controls/elements/ui-checkmark/ui-checkmark.component';
import { SearchLanguageComponent } from './components/search-language/search-language.component';
import { SearchCourseComponent } from './components/search-course/search-course.component';
import { SearchResponderLicenseTypesComponent } from './components/search-responder-license-type/search-responder-license-types.component';
import { UiCreditCardNumberComponent } from './controls/forms/ui-credit-card-number/ui-credit-card-number.component';
import { SelectSingleResponderModal } from './components/select-responder-single-modal/select-responder-single-modal.component';

import { UiBsTypeaheadComponent } from './controls/forms/ui-typeahead/ui-bs-typeahead/ui-bs-typeahead.component';
import { LookupContainsIdPipe } from './pipes/lookup-contains-id.pipe';
import { LookupContainsDisplayValuePipe } from './pipes/lookup-contains-display-value.pipe';
import { RmsFileUploadComponent } from './components/file-upload/rms-file-upload.component';
import { FileUploadConstants } from '../core-rms/file-upload.constants';
import { UiPhoneExtensionComponent } from './controls/forms/ui-phone-extension/ui-phone-extension.component';
import { SearchReasonsComponent } from './components/search-reasons/search-reasons.component';
import { SearchPositionComponent } from './components/search-position/search-position.component';
import { RmsLoadingSpinnerComponent } from './components/loading-spinner/rms-loading-spinner.component';
import { RmsLoadingService } from './components/loading-spinner/rms-loading.service';
import { SelectButton } from 'primeng/selectbutton';
import { BaseSideBarNavComponent } from './components/sidebar-nav/base-sidebar-nav.component';
import { SideBarMenuComponent } from './components/sidebar-nav/sidebar-nav-menu/side-bar-menu.component';
import { SidebarRendererComponent } from './components/sidebar-nav/sidebar-renderer/sidebar-renderer.component';
import { DropdownModule } from "primeng/dropdown";
import { AutoCompleteModule } from "primeng/autocomplete";
import { SidebarNavMenuService } from "../core-rms/sidebar-nav-menu.service";
import { MenuService } from "../core-rms/rms.menu.service";
import { SidebarNavService } from "../core-rms/sidebar-nav.service";
import { MaskDateDirective } from './controls/forms/ui-date/ui-date-mask.directive';
import { SearchAirportsModalComponent } from '../../responders/shared/responder-profile/travel-info/airports/search/search-airports-modal.component';
import { CanNumberEditComponent } from '../../rms-system-management/lookups/can-numbers/edit/can-number-edit.component';
import { CurrentEventComponent } from '../../components/current-event/current-event.component';
import { UiTimeComponent } from './controls/forms/ui-time/ui-time.component';
import { UITextComponent } from './controls/elements/ui-text/ui-text.component';
import { PayPeriodEditComponent } from '../../rms-system-management/lookups/payperiods/pay-period-edit/pay-period-edit.component';
import { HasPermissionDirective } from '../core-rms/has-permission.directive';
import { TimespanFormatPipe } from './pipes/timespan-format.pipe';
import { UiCurrencyComponent } from "./controls/forms/ui-currency/ui-currency.component";
import { UIHiddenInputComponent } from './controls/forms/ui-hidden-input/ui-hidden-input.component';
import { SelectLocationComponent } from './components/select-location/select-location.component';
import { FilterLocationComponent } from './components/select-location/filter-location/filter-location.component';
import { UiDatetimeComponent } from './controls/elements/ui-datetime/ui-datetime.component';
import { EditLocationComponent } from '../../events/event/locations/edit/edit-location.component';
import { ReportDataListComponent } from './components/report-data-list/report-data-list.component';
import { UiAltFormPanelComponent } from './controls/forms/ui-alt-form-panel/ui-alt-form-panel.component';
import { UiPanelComponent } from './controls/elements/ui-panel/ui-panel.component';
import { SearchCoursesModalComponent } from './components/search-courses-modal/search-courses-modal.component';
import { UiAutocompleteComponent } from './controls/forms/ui-autocomplete/ui-autocomplete.component';
import { SearchResponderComponent } from './components/select-responder-single-modal/search-responder/search-responder.component';

@NgModule({
  imports: [
    CommonModule,
    AutoCompleteModule,
    CheckboxModule,
    CalendarModule,
    TooltipModule.forRoot(),
    TypeaheadModule.forRoot(),
    UiNdmsModule,
    TreeModule,
    ToastModule,
    TextMaskModule,
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot(),
    DropdownModule
  ],
  declarations: [
    SearchTeamTextboxComponent,
    LeftNavComponent,
    SearchTeamModalComponent, SearchRespondersMultiModalComponent, SearchResponderModalComponent, TeamsSelectComponent,
    SelectSingleResponderModal,
    UiDatetimeComponent,
    SearchAirportComponent,
    SearchCertificationTypeComponent,
    SearchLanguageComponent,
    SearchPositionComponent,
    SearchResponderLicenseTypesComponent,
    CurrentEventComponent,
    RmsNavComponent,
    RmsHomeComponent,
    ProgramCardComponent,
    UiFormPanelComponent,
    UiFormCardPanelComponent,
    UiFormCardPanelContainerComponent,
    UiTextboxComponent,
    UiNumberComponent,
    UiPhoneNumberComponent,
    UiPostalCodeComponent,
    UiEmailAddressComponent,
    UiDropDownComponent,
    UiCheckboxComponent,
    UiBasicCheckboxComponent,
    UiPrimengCheckboxComponent,
    UiDateComponent,
    UiPrintErrorsComponent,
    UiDropdownWithButtonComponent,
    UiTextareaComponent,
    UiSSNComponent,
    UiCheckmarkComponent,
    UiCurrencyComponent,
    UiCreditCardNumberComponent,
    SearchCourseComponent,
    RmsFileUploadComponent,
    LookupContainsDisplayValuePipe,
    LookupContainsIdPipe,
    UiBsTypeaheadComponent,
    UiPhoneExtensionComponent,
    SearchReasonsComponent,
    RmsLoadingSpinnerComponent,
    BaseSideBarNavComponent,
    SideBarMenuComponent,
    SidebarRendererComponent,
    MaskDateDirective,
    UiTimeComponent,
    SearchAirportsModalComponent,
    CanNumberEditComponent,
    UITextComponent,
    PayPeriodEditComponent,
    HasPermissionDirective,
    TimespanFormatPipe,
    UIHiddenInputComponent,
    SelectLocationComponent,
    FilterLocationComponent,
    EditLocationComponent,
    ReportDataListComponent,
    UiAltFormPanelComponent,
    UiPanelComponent,
    SelectButton,
    SearchCoursesModalComponent,
    UiAutocompleteComponent,
    SearchResponderComponent
  ],
  exports: [
    SearchTeamTextboxComponent,
    LeftNavComponent,
    SearchRespondersMultiModalComponent,
    SearchResponderModalComponent,
    TeamsSelectComponent,
    UiNdmsModule,
    SearchAirportComponent,
    SearchCertificationTypeComponent,
    SearchCourseComponent,
    SearchLanguageComponent,
    SearchPositionComponent,
    SearchResponderLicenseTypesComponent,
    CurrentEventComponent,
    RmsNavComponent,
    UiAltFormPanelComponent,
    UiAutocompleteComponent,
    UiFormPanelComponent,
    UiFormCardPanelComponent,
    UiFormCardPanelContainerComponent,
    UiTextboxComponent,
    UiTimeComponent,
    UiNumberComponent,
    UiPhoneNumberComponent,
    UiPostalCodeComponent,
    UiEmailAddressComponent,
    UiDropDownComponent,
    UiCheckboxComponent,
    UiBasicCheckboxComponent,
    UiPrimengCheckboxComponent,
    UiDateComponent,
    UiPrintErrorsComponent,
    UiDropdownWithButtonComponent,
    UiTextareaComponent,
    UiCurrencyComponent,
    TextMaskModule,
    UiSSNComponent,
    UiCheckmarkComponent,
    UiCreditCardNumberComponent,
    UiBsTypeaheadComponent,
    LookupContainsDisplayValuePipe,
    LookupContainsIdPipe,
    RmsFileUploadComponent,
    TooltipModule,
    DropdownModule,
    AutoCompleteModule,
    TypeaheadModule,
    UiPhoneExtensionComponent,
    SearchReasonsComponent,
    RmsLoadingSpinnerComponent,
    SelectButton,
    BaseSideBarNavComponent,
    SideBarMenuComponent,
    SidebarRendererComponent,
    MaskDateDirective,
    UITextComponent,
    UiDatetimeComponent,
    HasPermissionDirective,
    TimespanFormatPipe,
    UIHiddenInputComponent,
    EditLocationComponent,
    ReportDataListComponent,
    UiPanelComponent
  ],
  entryComponents: [
    SelectSingleResponderModal,
    RmsLoadingSpinnerComponent,
    SearchAirportsModalComponent,
    CanNumberEditComponent,
    PayPeriodEditComponent,
    SelectLocationComponent,
    SearchCoursesModalComponent
  ],
  providers: [
    FileUploadConstants,
    RmsLoadingService,
    RmsLoadingSpinnerService,
    SidebarNavMenuService,
    MenuService,
    SidebarNavService,
    SearchAirportsModalComponent,
    CanNumberEditComponent,
    PayPeriodEditComponent,
    TimespanFormatPipe
  ]
})
export class UiRmsModule { }
